import apiClient from '@/lib/api/apiClient'
import { showApiError } from '@/lib/utils/notifications'

/**
 * Angular `FileUploadURLComponent.downloadFile`: strips CDN origin so `serve-file-config` receives the S3 key.
 */
export function stripVersionUploadUrlToServeConfigPath(filePath: string): string {
  if (!filePath?.trim()) return ''
  try {
    return filePath.replace(/^https?:\/\/[^/]+\/?/, '')
  } catch {
    return ''
  }
}

/** Angular hardcodes `23` and `ORGANIZATION_COLLAPSED` for this upload dialog's Download File link. */
export const VERSION_UPLOAD_DOWNLOAD_SERVE_FILE_ID = 23
export const VERSION_UPLOAD_DOWNLOAD_SERVE_TYPE = 'ORGANIZATION_COLLAPSED'

export async function openVersionUploadedImageDownload(uploadedFileUrl: string): Promise<void> {
  if (!uploadedFileUrl.trim()) return
  const s3Key = stripVersionUploadUrlToServeConfigPath(uploadedFileUrl)
  if (!s3Key) return
  const encodedPath = encodeURIComponent(s3Key)
  try {
    const { data } = await apiClient.get<Blob>(
      `/serve-file-config/${VERSION_UPLOAD_DOWNLOAD_SERVE_TYPE}/${VERSION_UPLOAD_DOWNLOAD_SERVE_FILE_ID}/?url=${encodedPath}`,
      { responseType: 'blob' },
    )
    const objectUrl = window.URL.createObjectURL(data)
    window.open(objectUrl, '_blank', 'noopener,noreferrer')
  } catch (error) {
    showApiError(error)
  }
}
